import React, { useState } from 'react';

import PropTypes from 'prop-types';

import { Button } from '@/components/ui/button';
import Dialog from './Dialog';

const CancelMenu = ({ currentPeriodEndAt, onCancel }) => {
  const [showDialog, setShowDialog] = useState(false);

  const handleCloseDialog = () => {
    setShowDialog(false);
  };

  const handleOpenDialog = () => {
    setShowDialog(true);
  };

  return (
    <>
      <Button onClick={handleOpenDialog} variant="destructive">
        Cancel plan
      </Button>

      <Dialog
        currentPeriodEndAt={currentPeriodEndAt}
        isOpen={showDialog}
        onCancel={onCancel}
        onClose={handleCloseDialog}
      />
    </>
  );
};

CancelMenu.propTypes = {
  currentPeriodEndAt: PropTypes.string.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default CancelMenu;
